import styles from "../../../Style";
import { Text } from "react-native";
import Switch from "@mui/material/Switch";
import CustomDropdown from "../../../../Components/DropDown/CustomDropdown";
import moment from "moment";
import Icons from "../../../../Constants/Icons";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { useFormContext } from "../FormProvider";
import { useEffect } from "react";

const AutoRepeat = ({ name, EventDetails }) => {

  const { formData, setFormData, errors } = useFormContext();

  useEffect(() => {
    // onChangeWeeklyWithoutCheckIn();
  }, []);
  // const onChangeWeeklyWithoutCheckIn = () => {
  //   let baseDateByWeekly =
  //     formData.ShowDate != "" ? moment(formData.ShowDate) : moment();
  //   const nextDate =
  //     formData.RepeatType === "Weekly"
  //       ? baseDateByWeekly.clone().add(1, "week").toDate()
  //       : formData.RepeatType === "BiWeekly"
  //       ? baseDateByWeekly.clone().add(2, "weeks").toDate()
  //       : formData.RepeatType === "Monthly"
  //       ? baseDateByWeekly.clone().add(1, "month").toDate()
  //       : "";

  //   setFormData((prevForm) => {
  //     const formattedDate = moment(nextDate, "MM/DD/YYYY").isValid()
  //       ? moment(nextDate, "MM/DD/YYYY").format("DD/MM/YYYY")
  //       : "";
  //     const RepeatEndDate =
  //       nextDate && moment(nextDate).isValid()
  //         ? moment(nextDate).add(1, "year").format("MM/DD/YYYY")
  //         : "";
  //     return {
  //       ...prevForm,
  //       RepeatType: formData.RepeatType,
  //       RepeatStartDate: formattedDate,
  //       RepeatEndDate: formData.RepeatType === "Custom" ? null : RepeatEndDate,
  //     };
  //   });
  // };

  const calculateDate = (WeekMonth, DayWeek) => {
    const baseDate = formData.ShowDate ? moment(formData.ShowDate) : moment();
    const dayIndex = moment().isoWeekday(DayWeek).isoWeekday();

    let targetDate = baseDate.clone().startOf("month");
    while (targetDate.isoWeekday() !== dayIndex) {
      targetDate.add(1, "days");
    }

    if (targetDate.isBefore(moment(), "day")) {
      targetDate.add(1, "month").startOf("month");
      while (targetDate.isoWeekday() !== dayIndex) {
        targetDate.add(1, "days");
      }
    }

    if (WeekMonth === "second") {
      targetDate.add(1, "week");
    } else if (WeekMonth === "third") {
      targetDate.add(2, "weeks");
    } else if (WeekMonth === "fourth") {
      targetDate.add(3, "weeks");
    } else if (WeekMonth === "last") {
      targetDate.endOf("month");
      while (targetDate.isoWeekday() !== dayIndex) {
        targetDate.subtract(1, "days");
      }
    }

    if (targetDate.isBefore(moment(), "day")) {
      targetDate.add(1, "week");
    }
    return moment(targetDate.toDate(), "MM/DD/YYYY").format("DD/MM/YYYY");
  };


  return (
    <div
      style={{
        filter:
          !["Admin Event Add", "Admin Event Repeat"].includes(name) &&
            !EventDetails?.scheduleEvent?.doRepeat
            ? "brightness(0.5)"
            : "",

        pointerEvents:
          !["Admin Event Add", "Admin Event Repeat"].includes(name) &&
            !EventDetails?.scheduleEvent?.doRepeat
            ? "none"
            : "auto",
      }}
    >
      <div className="Switch_event" style={{ marginBottom: "20px" }}>
        <Text style={styles.labelPhoto}>Auto-Repeat</Text>

        <Switch
          color="primary"
          name="Status"
          onChange={() => {
            setFormData((prevForm) => ({
              ...prevForm,
              AutoRepeat: !formData.AutoRepeat,
            }));
            if (formData.AutoRepeat === false) {
              setFormData((prevForm) => ({
                ...prevForm,
                WeekMonth: null,
                DayWeek: null,
                RepeatType: null,
                RepeatEndDate: null,
                RepeatStartDate: null,
              }));
            }
          }}
          value={formData.AutoRepeat}
          checked={!!formData.AutoRepeat}
        />
      </div>
      <div
        className={`${formData.AutoRepeat ? "display-block" : "display-none"}`}
      >
        <div
          className={`Category_name Subcategory_drop weeklyDate-cp ${errors.RepeatType ? "invalid" : "valid"
            }`}
          style={styles.CustomDrop}
        >
          <CustomDropdown
            dropDownLabel={
              formData.RepeatType === "" || formData.RepeatType === null ? (
                <div style={{ color: "rgb(129, 129, 129)" }}>
                  Select Repeat Type
                </div>
              ) : (
                formData.RepeatType
              )
            }
            items={["Weekly", "BiWeekly", "Monthly", "Custom"]}
            color="blue"
            onSelect={(items) => {
              let baseDateByWeekly =
                formData.ShowDate != "" ? moment(formData.ShowDate) : moment();
              const nextDate =
                items === "Weekly"
                  ? baseDateByWeekly.clone().add(1, "week").toDate()
                  : items === "BiWeekly"
                    ? baseDateByWeekly.clone().add(2, "weeks").toDate()
                    : items === "Monthly"
                      ? baseDateByWeekly.clone().add(1, "month").toDate()
                      : "";

              setFormData((prevForm) => {
                const formattedDate = moment(nextDate, "MM/DD/YYYY").isValid()
                  ? moment(nextDate, "MM/DD/YYYY").format("DD/MM/YYYY")
                  : "";
                const RepeatEndDate =
                  nextDate && moment(nextDate).isValid()
                    ? moment(nextDate).add(1, "year").format("MM/DD/YYYY")
                    : "";
                return {
                  ...prevForm,
                  RepeatType: items,
                  RepeatStartDate: formattedDate,
                  RepeatEndDate: items === "Custom" ? null : RepeatEndDate,
                };
              });
            }}
            customLabelStyle={{
              fontWeight: "400",
              color: "white",
              width: "100%",
            }}
          />
        </div>
      </div>
      {formData.RepeatType && (
        <div
          className={` ${formData.AutoRepeat ? "display-block" : "display-none"
            }`}
        >
          {formData.RepeatType === "Custom" && (
            <div>
              <div style={{ fontSize: "12px", marginBottom: "10px" }}>
                Which Week Of The Month Is Your Show?
              </div>
              <div
                className={`Category_name Subcategory_drop weeklyDate-cp ${errors.WeekMonth ? "invalid" : "valid"
                  }`}
                style={styles.CustomDrop}
              >
                <CustomDropdown
                  dropDownLabel={
                    formData.WeekMonth === "" || formData.WeekMonth === null ? (
                      <div style={{ color: "rgb(129, 129, 129)" }}>
                        Select Week Of The Month
                      </div>
                    ) : (
                      formData.WeekMonth
                    )
                  }
                  items={["first", "second", "third", "fourth", "last"]}
                  color="blue"
                  onSelect={(items) => {
                    setFormData((prevForm) => {
                      const dayWeekValue =
                        formData.DayWeek === null || formData.DayWeek === ""
                          ? ""
                          : formData.DayWeek;

                      const repeatStartDate = calculateDate(
                        items,
                        dayWeekValue
                      );
                      const repeatEndDate = moment(
                        repeatStartDate,
                        "DD/MM/YYYY"
                      )
                        .add(1, "year")
                        .format("MM/DD/YYYY");

                      return {
                        ...prevForm,
                        WeekMonth: items,
                        RepeatStartDate: repeatStartDate,
                        RepeatEndDate: repeatEndDate,
                      };
                    });
                  }}
                  customLabelStyle={{
                    fontWeight: "400",
                    color: "white",
                    width: "100%",
                  }}
                />
              </div>
              <div style={{ fontSize: "12px", marginBottom: "10px" }}>
                What Day Of The Week Is Your Show
              </div>
              <div
                className={`Category_name weeklyDate-cp Subcategory_drop ${errors.DayWeek ? "invalid" : "valid"
                  }`}
                style={styles.CustomDrop}
              >
                <CustomDropdown
                  dropDownLabel={
                    formData.DayWeek === "" || formData.DayWeek === null ? (
                      <div style={{ color: "rgb(129, 129, 129)" }}>
                        Select Day Of The Week
                      </div>
                    ) : (
                      formData.DayWeek
                    )
                  }
                  items={[
                    "monday",
                    "tuesday",
                    "wednesday",
                    "thursday",
                    "friday",
                    "saturday",
                    "sunday",
                  ]}
                  color="blue"
                  onSelect={(items) => {
                    setFormData((prevForm) => {
                      const weekMonthValue =
                        formData.WeekMonth === null || formData.WeekMonth === ""
                          ? ""
                          : formData.WeekMonth;

                      const repeatStartDate = calculateDate(
                        items,
                        weekMonthValue
                      );
                      const repeatEndDate = moment(
                        calculateDate(weekMonthValue, items),
                        "DD/MM/YYYY"
                      )
                        .add(1, "year")
                        .format("MM/DD/YYYY");

                      return {
                        ...prevForm,
                        RepeatEndDate: repeatEndDate,
                        DayWeek: items,
                        RepeatStartDate: repeatStartDate,
                      };
                    });
                  }}
                  customLabelStyle={{
                    fontWeight: "400",
                    color: "white",
                    width: "100%",
                  }}
                />
              </div>
            </div>
          )}

          <div
            style={styles.EventDate}
            className={`ticket-date ${formData.AutoRepeat ? "display-block" : "display-none"
              }`}
          >
            <div
              className={`Category_name weeklyDate-cp valid`}
              style={{ marginBottom: "20px", width: "100%" }}
            >
              <DatePicker
                selected={formData.RepeatEndDate}
                dateFormat="yyyy/MM/dd"
                minDate={moment(formData.RepeatStartDate, "DD/MM/YYYY")
                  .add(1, "days")
                  .format("MM/DD/YYYY")}
                placeholderText="Start Date"
                showPopperArrow={false}
                onChange={(date) => {
                  setFormData((prevForm) => ({
                    ...prevForm,
                    RepeatEndDate: date,
                  }));
                }}
                showTimeSelect={false}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                customInput={
                  <div style={styles.startDate}>
                    <img src={Icons.Ic_newdate} style={{ height: "20px" }} />
                    <div className="fontSize16">
                      {formData.RepeatEndDate ? (
                        format(formData.RepeatEndDate, "MM/dd/yyyy")
                      ) : (
                        <div style={styles.customText_ad}>End Date</div>
                      )}
                    </div>
                  </div>
                }
              />
            </div>

            <div style={{ marginBottom: "20px", width: "100%" }}>
              <div
                style={{
                  paddingTop: "10px",
                  paddingLeft: "10px",
                  fontSize: "14px",
                  color: "red",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <img src={Icons.Ic_newdate} style={{ height: "20px" }} />
                {formData.RepeatStartDate === "" ||
                  formData.RepeatStartDate === null
                  ? "MM/DD/YYYY"
                  : moment(formData.RepeatStartDate, "DD/MM/YYYY").format(
                    "MM/DD/YYYY"
                  )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AutoRepeat;
